// This HOC wraps widgets to be displaed in the WidgetBar. Therefore they dont need access to redux,
// i.e. real data. The mock data is provided through this HOC.

import React from "react";

import MockOverlay from "./overlays/MockOverlay";

import { 
  //widgetConsumesHistoData, 
  colors } from "../../../../helpers/constants";

function wrapMockedWidget(WrappedWidget) {
  class WidgetWrapper extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = { hovered: false };
    }
    render() {
      let { label } = this.props;
      let { hovered } = this.state;
      let headername = label;
      let widgetColor = colors["selected"];

      //let _widgetConsumesHistoData = widgetConsumesHistoData(widgetType);
      let histoSensorValues = [
        { date: "2019-01-01", sensorid: "139", value: "0.26" },
        { date: "2019-01-02", sensorid: "139", value: "1.68" },
        { date: "2019-01-03", sensorid: "139", value: "0.26" },
        { date: "2019-01-04", sensorid: "139", value: "1.68" },
        { date: "2019-01-05", sensorid: "139", value: "0.26" },
        { date: "2019-01-06", sensorid: "139", value: "1.68" }
      ];

      // Overlay
      let Overlay = null;
      if (hovered) {
        Overlay = <MockOverlay />;
      }
      return (
        <div
          className="widget mockwidget"
          onMouseEnter={() => {
            this.setState({ hovered: true });
          }}
          onMouseLeave={() => {
            this.setState({ hovered: false });
          }}
          style={{ height: 200 }}
        >
          {Overlay}
          {true && (
            <div className="widget-header-container">
              <div
                className="widget-header"
                style={{ backgroundColor: "#e0e0e0", color: "black" }}
              >
                {" "}
                {headername}
              </div>
            </div>
          )}

          <div className={"widget-content"}>
            <WrappedWidget
              {...this.props}
              liveSensorValue={{ value: 42 }}
              thisWidgetConfig={{
                widgetSettings: { showAxes: false, showPoints: true, upper_limit: 80, lower_limit: 0, interval: 2 }
              }}
              widgetColor={widgetColor}
              histoSensorValuesForSensors={{ 0: histoSensorValues }}
              colorsForSensors={{ 0: widgetColor }}
              coords={{ x1: 0, x2: 200, y1: 0, y2: 200 }}
              widgetSize={{width: 200, height: 200}}
              isMock={true}
            />
          </div>
        </div>
      );
    }
  }

  return WidgetWrapper;
}

export default wrapMockedWidget;
